import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13 7.5A5.5 5.5 0 0 1 7.5 13H2.55a.55.55 0 0 1-.55-.55V7.5a5.5 5.5 0 1 1 11 0M4.42 6c0-.608.492-1 1.1-1h3.96c.607 0 1.1.392 1.1 1s-.492 1-1.1 1H5.52c-.608 0-1.1-.392-1.1-1M4.2 9c0-.608.492-1 1.1-1h1.54c.607 0 1.1.392 1.1 1s-.493 1-1.1 1H5.3c-.608 0-1.1-.392-1.1-1m6.8 7.5a5.5 5.5 0 0 0 5.5 5.5h4.95a.55.55 0 0 0 .55-.55V16.5a5.5 5.5 0 1 0-11 0m8.58-1.5c0-.607-.492-1-1.1-1h-3.96c-.607 0-1.1.393-1.1 1s.492 1 1.1 1h3.96c.608 0 1.1-.393 1.1-1m.22 3c0-.608-.492-1-1.1-1h-1.54c-.608 0-1.1.392-1.1 1s.493 1 1.1 1h1.54c.608 0 1.1-.392 1.1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgDoubleConversationFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DoubleConversationFilled_default = SvgDoubleConversationFilled;

export { DoubleConversationFilled_default as default };
